import React, { FC } from 'react'
import './truck-trailer.scss'

type Props = {
    title: string,
    value?: string
}

export const TruckTrailer: FC<Props> = ({ title, value }) => {
    return (
        <div className={`truck-trailer-heading-item-container`}>
            <div className={'truck-trailer-heading-item-title'}>{title}</div>
            <div className={'truck-trailer-heading-item-colon'}>:</div>
            <div className={'truck-trailer-heading-item-value'}>{value}</div>
        </div>
    )
}